export function throwObject (obj) {
  // eslint-disable-next-line no-throw-literal
  throw obj
}
